export const events = {
  createOneOnOne: 'Create one on one',
  addOneToOneTask: 'Add one to one task',
  saveTalkingPointOrPrivateNote: 'Save talking point or Private note',
  addOneToOneTranscript: 'Add one to one transcript',
}
